import { Form, Input, InputNumber } from "antd";
import React from "react";
import { EMPTY_REQUIRED_FIELD_MESSAGE } from "../../constants/constants";
import InputField from "../InputField/InputField";
import Typography from "../Typography/Typography";

const Step1Form = ({ formInstance, urlRules, emptyInputRule }) => {
  return (
    <>
      <Typography
        h2
        style={{
          marginTop: "23.89px",
          fontWeight: "600",
          fontSize: "20px",
          marginBottom: 0,
        }}
      >
        Company details
      </Typography>
      <div className="form-container">
        <Form.Item rules={emptyInputRule} name="company_legal_name">
          <InputField
            placeholder="S.H.I.E.L.D"
            inputLabel="Company registered name"
            showRequiredIcon
            maxLength={200}
            onChange={(e) => formInstance.setFieldsValue({ company_legal_name: e.target.value })}
            style={{ width: "216px" }}
            autoFocus
          />
        </Form.Item>
        <Form.Item rules={urlRules} name="website_url">
          <InputField
            placeholder="https://agentsofshield.com"
            inputLabel="Website URL"
            showRequiredIcon
            onChange={(e) => formInstance.setFieldsValue({ website_url: e.target.value })}
            maxLength={2048}
            style={{ width: "216px" }}
          />
        </Form.Item>
        <Form.Item rules={emptyInputRule} name="address">
          <InputField
            placeholder="219 West 47th Street, New York City, New York"
            inputLabel="Company address"
            showRequiredIcon
            maxLength={200}
            onChange={(e) => formInstance.setFieldsValue({ address: e.target.value })}
            style={{ width: "450px" }}
          />
        </Form.Item>
        <Form.Item rules={emptyInputRule} name="city">
          <InputField
            placeholder="New York"
            inputLabel="City"
            showRequiredIcon
            maxLength={200}
            onChange={(e) => formInstance.setFieldsValue({ city: e.target.value })}
            style={{ width: "216px" }}
          />
        </Form.Item>
        <Form.Item rules={emptyInputRule} name="zipcode">
          <InputField
            placeholder="11501"
            inputLabel="Pincode / ZIP"
            showRequiredIcon
            maxLength={200}
            onChange={(e) => formInstance.setFieldsValue({ zipcode: e.target.value })}
            style={{ width: "216px" }}
          />
        </Form.Item>
        <Form.Item rules={emptyInputRule} name="country">
          <InputField
            placeholder="USA"
            inputLabel="Country"
            maxLength={200}
            showRequiredIcon
            onChange={(e) => formInstance.setFieldsValue({ country: e.target.value })}
            style={{ width: "216px" }}
          />
        </Form.Item>
      </div>
    </>
  );
};

export default Step1Form;
